@if (messages$ | async; as messages) {
  <div id="global-message">
    @for (assistiveMsg of messages[messageType.MSG_TYPE_ASSISTIVE]; track assistiveMsg) {
      <ng-container>
        <div class="cx-visually-hidden">
          <span class="pl-3">{{ assistiveMsg | cxTranslate }}</span>
        </div>
      </ng-container>
    }
    @for (confMsg of messages[messageType.MSG_TYPE_CONFIRMATION]; track confMsg; let i = $index) {
      @if (confMsg.key !== key3) {
        <div class="alert alert-success">
          <span class="pl-3">{{ confMsg | cxTranslate }}</span>
          <button class="close" type="button" (click)="clear(messageType.MSG_TYPE_CONFIRMATION, i)">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        </div>
      }
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_INFO]; track infoMsg; let i = $index) {
      <div class="alert alert-info">
        <span class="pl-3">{{ infoMsg | cxTranslate }}</span>
        <button class="close" type="button" (click)="clear(messageType.MSG_TYPE_INFO, i)">
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
    @for (
      infoMsg of messages[messageType.MSG_TYPE_WARNING]; track
      infoMsg; let i = $index) {
      <div class="alert alert-warning">
        <span class="pl-3">{{ infoMsg | cxTranslate }}</span>
        <button class="close" type="button" (click)="clear(messageType.MSG_TYPE_WARNING, i)">
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
    @for (errorMsg of messages[messageType.MSG_TYPE_ERROR]; track errorMsg; let i = $index) {
      @if (canShowThisError(errorMsg)) {
        @if (i === messages[messageType.MSG_TYPE_ERROR].length - 1) {
          <div class="alert alert-danger">
            <span class="pl-3" [innerHTML]="errorMsg | cxTranslate"></span>
            <button class="close" type="button" (click)="clear(messageType.MSG_TYPE_ERROR, i)">
              <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
            </button>
          </div>
        }
      }
    }
  </div>
}